import React from 'react';
import { Outlet } from 'react-router-dom';

import { Wrap } from '@components';

const GuidePage = () => {
  return (
    <Wrap>
      <Outlet />
    </Wrap>
  );
};

export default GuidePage;
